const CLASSES = {
  CRUSADER: "Crusader",
  INQUISITOR: "Inquisitor",
  SHEPHERD: "Shepherd",
}

export default CLASSES;